/**
 * Diritti per il profilo di utenza
 * Enumerazione creata con Mod 1128556
 */
export class ClientPrivileges {
    privilegeName: string = "";

    constructor(privilegeName: string) {
        this.privilegeName = privilegeName;
    }

    public toString(): string {
        return this.privilegeName;
    }

    public valueOf() {
        return this.privilegeName;
    }

    public and(privilege2: ClientPrivileges) {
        let splittedPrivileges = privilege2.privilegeName.split(",");
        let toReturn = ClientPrivileges.None;
        for (let privilege of splittedPrivileges) {
            if (this != null && privilege != null && this.privilegeName.includes(privilege)) toReturn = toReturn.or(privilege2);
        }
        return toReturn;
    }

    public or(privilege2: ClientPrivileges) {
        if (this == null || this.equals(ClientPrivileges.None)) return privilege2;
        if (privilege2 == null || privilege2.equals(ClientPrivileges.None)) return this;
        return new ClientPrivileges(this.privilegeName + "," + privilege2.privilegeName);
    }

    public equals(privilege2: ClientPrivileges) {
        if (this == null) {
            return privilege2 == null;
        }
        return this.privilegeName == privilege2.privilegeName;
    }

    /**Nessuno */
    static readonly None: ClientPrivileges = new ClientPrivileges("None");

    /** Super admin */
    static readonly SuperAdmin: ClientPrivileges = new ClientPrivileges("SuperAdmin");

    /**Gestione utenti */
    static readonly UsersManagement: ClientPrivileges = new ClientPrivileges("UsersManagement");

    /**Gestione organizzazioni */
    static readonly OrganizationsManagement: ClientPrivileges = new ClientPrivileges("OrganizationsManagement");

    /**On-boarding dei dispositivi */
    static readonly OnBoarding: ClientPrivileges = new ClientPrivileges("OnBoarding");

    /**Gestione dispositivi (organizzazione in cartelle e dismissione) */
    static readonly DevicesManagement: ClientPrivileges = new ClientPrivileges("DevicesManagement");

    /**Gestione aggiornamenti */
    static readonly UpdatesManagement: ClientPrivileges = new ClientPrivileges("UpdatesManagement");

    /**Gestione statistiche fitness */
    static readonly FitnessStatisticsManagement: ClientPrivileges = new ClientPrivileges("FitnessStatisticsManagement");

    /**
     * Gestione stato dei dispositivi
     * Mod 1338780
     */
    static readonly StatusManagement: ClientPrivileges = new ClientPrivileges("StatusManagement");

    /**
     * scrittura schedule sicurezza  dei dispositivi
     * Mod 1349807
     */
    static readonly SecurityScheduleWrite: ClientPrivileges = new ClientPrivileges("SecurityScheduleWrite");

    /**
     * Lettura bande
     * Mod 1349807
     */
    static readonly ReadBands: ClientPrivileges = new ClientPrivileges("ReadBands");

    /**
     * Scrittura bande
     * Mod 1349807
     */
    static readonly WriteBands: ClientPrivileges = new ClientPrivileges("WriteBands");

    /**
     * Lettura allarmi
     * Mod 1349807
     */
    static readonly ReadAlarms: ClientPrivileges = new ClientPrivileges("ReadAlarms");

    /**
     * Scrittura allarmi
     * Mod 1349807
     */
    static readonly WriteAlarms: ClientPrivileges = new ClientPrivileges("WriteAlarms");

    /**
     * Lettura ritardi
     * Mod 1349807
     */
    static readonly ReadDelays: ClientPrivileges = new ClientPrivileges("ReadDelays");

    /**
     * Scrittura ritardi
     * Mod 1349807
     */
    static readonly WriteDelays: ClientPrivileges = new ClientPrivileges("WriteDelays");

    /**
     * Lettura rulli
     * Mod 1349807
     */
    static readonly ReadRolls: ClientPrivileges = new ClientPrivileges("ReadRolls");

    /**
     * Scrittura rulli
     * Mod 1349807
     */
    static readonly WriteRolls: ClientPrivileges = new ClientPrivileges("WriteRolls");

    /**
     * Gestione sicurezza
     * Mod 1349807
     */
    static readonly SecurityManagement: ClientPrivileges = new ClientPrivileges("SecurityManagement");

    /**
     * Controllo giacenze device
     * MOD 1410822
     */
    static readonly CashFlowContentMonitoring: ClientPrivileges = new ClientPrivileges("CashFlowContentMonitoring");

    /**
     * Report transazioni
     * MOD 1410822
     */
    static readonly CashFlowTransactionsReporting: ClientPrivileges = new ClientPrivileges("CashFlowTransactionsReporting");

    /**Gestione opzioni client */
    static readonly OptionsManagement: ClientPrivileges = new ClientPrivileges("OptionsManagement");

    /**Gestione pacchetti di aggiornamento */
    static readonly PackagesManagement: ClientPrivileges = new ClientPrivileges("PackagesManagement");

    /** Report workload*/
    static readonly CashFlowWorkloadReporting: ClientPrivileges = new ClientPrivileges("CashFlowWorkloadReporting");

    /** Pagina di Branch Report confronto front/back */
    static readonly CashFlowBranchReporting: ClientPrivileges = new ClientPrivileges("CashFlowBranchReporting");

    /** Pagina di Users Balance Report*/
    static readonly UsersBalanceReport: ClientPrivileges = new ClientPrivileges("UsersBalanceReport");

    /** Pagina di Channels Balance Report*/
    static readonly ChannelsBalanceReport: ClientPrivileges = new ClientPrivileges("ChannelsBalanceReport");

    /** Pagina di Channels Balance Report*/
    static readonly GetBagsCashReport: ClientPrivileges = new ClientPrivileges("GetBagsCashReport");

    /** Richiesta di azioni autorizzate */
    static readonly AuthActions: ClientPrivileges = new ClientPrivileges("AuthActions");

    /** Caricamento e rimozione pacchetti di aggiornamento */
    static readonly UploadUpdatePackages: ClientPrivileges = new ClientPrivileges("UploadUpdatePackages");

    /** Scaricamento log */
    static readonly DownloadLogs: ClientPrivileges = new ClientPrivileges("DownloadLogs");

    /** Gestione branch */
    static readonly BranchesManagement: ClientPrivileges = new ClientPrivileges("BranchesManagement");

    /** Gestione delle licenze dei dispositivi */
    static readonly DeviceLicenseManagement: ClientPrivileges = new ClientPrivileges("DeviceLicenseManagement");

    /** Visualizzazione dei risultati della manutenzione predittiva */
    static readonly ReadPredictiveMaintenance: ClientPrivileges = new ClientPrivileges("ReadPredictiveMaintenance");

    /**  Gestione dello scheduling della manutenzione */
    static readonly SchedulePredictiveMaintenance: ClientPrivileges = new ClientPrivileges("SchedulePredictiveMaintenance");

    /** Gestione della analisi log */
    static readonly LogAnalysis: ClientPrivileges = new ClientPrivileges("LogAnalysis");

    /** Visualizzazione stato della manutenzione preventiva (service counters) */
    static readonly PreventiveMaintenanceStatus: ClientPrivileges = new ClientPrivileges("PreventiveMaintenanceStatus");

    /** Monitoraggio metriche di rete */
    static readonly ReadNetworkMetrics: ClientPrivileges = new ClientPrivileges("ReadNetworkMetrics");

    /* Gestione pagina di configurazione rulli */
    static readonly RollsConfigurationManagement: ClientPrivileges = new ClientPrivileges("RollsConfigurationManagement");

    /* Gestione pagina di configurazioni di riferimento */
    static readonly ReferenceConfigurationManagement: ClientPrivileges = new ClientPrivileges("ReferenceConfigurationManagement");

    /* Gestione pagina di sincronizzazione utenti caos */
    static readonly CaosUserSyncManagement: ClientPrivileges = new ClientPrivileges("CaosUserSyncManagement");

    /* Gestione configurazioni di caos */
    static readonly CaosConfigurationManagement: ClientPrivileges = new ClientPrivileges("CaosConfigurationManagement");

    /* Visualizzazione eventi utente */
    static readonly ReadUserEvents: ClientPrivileges = new ClientPrivileges("ReadUserEvents");

    /* Visualizzazione pagina di platform maintenance*/
    static readonly PlatformMaintenance: ClientPrivileges = new ClientPrivileges("PlatformMaintenance");

    /* Gestione smart lock */
    static readonly SmartLockManagement: ClientPrivileges = new ClientPrivileges("SmartLockManagement");

    /* Gestione attivazione smart lock */
    static readonly SmartLockActivation: ClientPrivileges = new ClientPrivileges("SmartLockActivation");

    /* Gestione attivazione tunnel http */
    static readonly RemoteLinkHttp: ClientPrivileges = new ClientPrivileges("RemoteLinkHttp");

    /* Gestione attivazione tunnel caos db */
    static readonly RemoteLinkCaosDb: ClientPrivileges = new ClientPrivileges("RemoteLinkCaosDb");

    /* Gestione attivazione tunnel ultra vnc */
    static readonly RemoteLinkUltraVnc: ClientPrivileges = new ClientPrivileges("RemoteLinkUltraVnc");

    /* Gestione attivazione tunnel ssh */
    static readonly RemoteLinkSsh: ClientPrivileges = new ClientPrivileges("RemoteLinkSsh");

    /* Gestione attivazione tunnel c-service */
    static readonly RemoteLinkCService: ClientPrivileges = new ClientPrivileges("RemoteLinkCService");

    /* Gestione attivazione tunnel custom */
    static readonly RemoteLinkCustom: ClientPrivileges = new ClientPrivileges("RemoteLinkCustom");

    /* Gestione messaggi remoti dataflow */
    static readonly DataFlowRemoteMessageManagement: ClientPrivileges = new ClientPrivileges("DataFlowRemoteMessageManagement");

    /* Gestione servizi dataflow */
    static readonly DataFlowServicesManagement: ClientPrivileges = new ClientPrivileges("DataFlowServicesManagement");

    /* Gestione modulo anagrafica dataflow */
    static readonly DataFlowDeviceDetailsManagement: ClientPrivileges = new ClientPrivileges("DataFlowDeviceDetailsManagement");

    /* Visualizzazione dataflow feedbackd */
    static readonly DataFlowFeedbacksViewer: ClientPrivileges = new ClientPrivileges("DataFlowFeedbacksViewer");
}
